import React from 'react'
import FormControlCustom from './FormControlCustom'
import FormGroup from './form-group/FormGroup'
import {useLanguageForShared} from "../../utils/languages/useLanguageForShared";

const FormGroupCustom = ({
                             isSubmit,
                             errors,
                             structure = {},
                             onBlur,
                             dataForm,
                             ...rest
                         }: any) => {
    const {t} = useLanguageForShared();
    const colSize = structure?.col ? Object.keys(structure?.col).map((ele) => `col-${ele}-${structure.col[ele]}`).join(' ') : ''
    return (
        <div className={colSize}>
            <FormGroup
                name={structure.name}
                dataTest={structure.dataElement?.dataTest}
                display={structure.display}
                label={{label: structure.label || ''}}
                subLabel={{label: structure?.subLabel || ''}}
                error={{
                    isVisible: isSubmit && !!errors && !!errors[structure?.name],
                    message: t(
                        'errors.' + errors[structure?.name]?.code,
                        errors[structure?.name]?.params
                    ),
                }}
            >
                <FormControlCustom
                    isSubmit={isSubmit}
                    errors={errors}
                    structure={structure}
                    onBlur={onBlur}
                    dataForm={dataForm}
                    {...rest}
                />
            </FormGroup>
        </div>

    )
}

export default FormGroupCustom
